import React from 'react';
import PropTypes from 'prop-types';
import NameBox from './NameBox';
import { ViewAll } from '../../shared';
import CardHead from './CardHead';
import { useSelector } from 'react-redux';
import CircleSpinner from '../../../assets/svg/CircleSpinner';
import { ROLES } from '../../../constants';

export default function Card({
    heading,
    data,
    view,
    showAddButton = false,
    onClickAdd = () => {},
    onClickNext = () => {},
    allowedRoles = [
        ROLES.SUPER_ADMIN,
        ROLES.ADMIN,
        ROLES.CSM,
        ROLES.CONTENT_MANAGER,
        ROLES.SALES_AGENT,
    ],
    isLoading,
}) {
    const userRole = useSelector((s) => s.user?.role);

    if (!allowedRoles.includes(userRole)) return null;

    return (
        <div className='col-md-6 custom-col mb-lg-4 mb-2'>
            <div className='h-100 card-container ssc-shadow d-flex flex-column w-100 align-items-center p-lg-4 p-3'>
                <CardHead
                    onClickShowAddButton={onClickAdd}
                    showAddButton={showAddButton}
                    title={heading}
                />
                <div className='content-set-area flex-column d-flex w-100 align-items-start justify-content-start'>
                    {isLoading ? (
                        <div
                            className={`d-flex justify-content-center align-items-center w-100 ${isLoading ? 'min-h-2' : ''}`}
                        >
                            <CircleSpinner size='2.25rem' className='mb-5' />
                        </div>
                    ) : data?.length ? (
                        data?.map((record, index) => {
                            if (index < 5) {
                                return (
                                    <NameBox
                                        key={index}
                                        name={record.full_name ?? record.name}
                                        mail={record.email ?? ''}
                                        onClickNext={() => onClickNext(record)}
                                    />
                                );
                            }
                        })
                    ) : (
                        `${heading} not found`
                    )}
                </div>
                {data?.length > 4 && !isLoading && (
                    <div className='view-btn d-flex justify-content-start w-100'>
                        <ViewAll className='ssc-card-btn2 text-decoration-none' navigateTo={view} />
                    </div>
                )}
            </div>
        </div>
    );
}
Card.propTypes = {
    adminData: PropTypes.array,
    csmData: PropTypes.array,
    customers: PropTypes.array,
    docCategories: PropTypes.array,
    apiCall: PropTypes.func,
};
